const cardsData = [
  {
    title: '流浪地球2',
    tag: '科幻',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20style%2C%20deep%20space%20background%20with%20warm%20orange%20planet%20glow%2C%20futuristic%20spaceship%20silhouette%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20Chinese%20film%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-wandering-01&orientation=portrait',
    desc: '太阳急速老化，人类在地球表面建造万座行星发动机，开启长达2500年的流浪之旅。',
  },
  {
    title: '封神第一部',
    tag: '神话',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20movie%20poster%20style%2C%20ancient%20battlefield%20with%20dramatic%20storm%20clouds%2C%20golden%20lightning%2C%20mystical%20atmosphere%2C%20dark%20and%20warm%20tones%2C%20no%20text%2C%20no%20faces%2C%20artistic%20cinematic%20photography&width=500&height=700&seq=card-poster-fengshen-02&orientation=portrait',
    desc: '殷商末年，纣王暴虐无道，姬发觉醒反抗，一场封神大战即将开启。',
  },
  {
    title: '满江红',
    tag: '历史',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20style%2C%20ancient%20courtyard%20at%20night%20with%20red%20lanterns%2C%20dark%20mysterious%20atmosphere%2C%20intricate%20shadow%20patterns%2C%20warm%20crimson%20accents%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-manjiang-03&orientation=portrait',
    desc: '南宋年间，岳飞死后四年，一桩惊天阴谋在宰相府中悄然展开。',
  },
  {
    title: '孤注一掷',
    tag: '犯罪',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20movie%20poster%20style%2C%20dimly%20lit%20server%20room%20with%20flickering%20monitor%20screens%2C%20ominous%20red%20glow%2C%20tense%20atmosphere%2C%20cyberpunk%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-guzhu-04&orientation=portrait',
    desc: '程序员潘生与模特安娜被高薪诱骗至境外诈骗工厂，生死逃亡一触即发。',
  },
  {
    title: '八角笼中',
    tag: '剧情',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Rustic%20Chinese%20drama%20movie%20poster%20style%2C%20dusty%20boxing%20ring%20in%20mountain%20village%2C%20warm%20golden%20sunlight%2C%20gritty%20realistic%20texture%2C%20emotional%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-bajiao-05&orientation=portrait',
    desc: '退役格斗冠军向腾辉带领山区孤儿通过格斗寻找人生出路的故事。',
  },
  {
    title: '狂飙',
    tag: '刑侦',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20poster%20style%2C%20dark%20interrogation%20room%20with%20single%20harsh%20light%2C%20police%20procedural%20atmosphere%2C%20contrasting%20light%20and%20shadow%2C%20tense%20mood%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-kuangbiao-06&orientation=portrait',
    desc: '京海市扫黑除恶斗争中的正邪较量，横跨二十年的命运沉浮。',
  },
  {
    title: '漫长的季节',
    tag: '悬疑',
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20drama%20series%20poster%20style%2C%20autumn%20railway%20tracks%20with%20falling%20leaves%2C%20warm%20amber%20sunset%20light%2C%20melancholic%20atmosphere%2C%20rusty%20industrial%20background%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=500&height=700&seq=card-poster-season-07&orientation=portrait',
    desc: '一座北方小城，一桩跨越十八年的碎尸悬案，三个老人的命运纠葛。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            热门影片
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            口碑炸裂的国产影视佳作，每一部都值得反复品味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {cardsData.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer rounded-lg overflow-hidden bg-background-50"
            >
              <div className="aspect-[2/3] overflow-hidden bg-background-200 relative">
                <img
                  src={item.img}
                  alt={`《${item.title}》- 91电影视频热门影片`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
                  <span className="text-[10px] font-medium bg-primary-500 text-background-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-[10px] font-medium bg-background-950/70 text-background-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.year}
                  </span>
                </div>
              </div>
              <div className="p-2 md:p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  《{item.title}》
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 leading-relaxed mt-1 line-clamp-2 hidden sm:block">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}